/**
 * Dashboard cards (employee counts, same partition as dashboard table):
 * 対象者数 = 未着手 + 進行中 + 完了 (notOpenedYet + draft + submitted/resubmitted)
 */
import React, { useState, useEffect } from 'react';
import { API_BASE_URL } from '../../../../config';
import './DashboardCards.css';
import dashboardIcon1 from '../../../../assests/icons/dashboardIcon_1.png';
import dashboardIcon2 from '../../../../assests/icons/dashboardIcon_2.png';
import dashboardIcon3 from '../../../../assests/icons/dashboardIcon_3.png';
import dashboardIcon4 from '../../../../assests/icons/dashboardIcon_4.png';

export interface DashboardCounts {
  /** sent + draft + submitted + resubmission_requested + resubmitted (= card2+card3+card4) */
  pipelineTotal: number;
  /** sent + resubmission_requested */
  notOpenedYet: number;
  inProgress: number;
  /** submitted + resubmitted */
  completed: number;
}

const DashboardCards: React.FC = () => {
  const [counts, setCounts] = useState<DashboardCounts>({
    pipelineTotal: 0,
    notOpenedYet: 0,
    inProgress: 0,
    completed: 0,
  });
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    let cancelled = false;
    fetch(`${API_BASE_URL}/api/employees/dashboard-counts`)
      .then((res) => (res.ok ? res.json() : Promise.reject(new Error('Failed to load counts'))))
      .then((data: Record<string, unknown>) => {
        if (!cancelled) {
          setCounts({
            pipelineTotal: Number(data.pipelineTotal) || 0,
            notOpenedYet: Number(data.notOpenedYet) || 0,
            inProgress: Number(data.inProgress) || 0,
            completed: Number(data.completed) || 0,
          });
        }
      })
      .catch(() => {
        if (!cancelled) {
          setCounts({ pipelineTotal: 0, notOpenedYet: 0, inProgress: 0, completed: 0 });
        }
      })
      .finally(() => {
        if (!cancelled) setLoading(false);
      });
    return () => {
      cancelled = true;
    };
  }, []);

  const cards = [
    {
      id: 'pipeline-total' as const,
      title: ['対象者数'],
      count: counts.pipelineTotal,
      icon: dashboardIcon1,
    },
    {
      id: 'not-opened-yet' as const,
      title: ['未着手'],
      count: counts.notOpenedYet,
      icon: dashboardIcon2,
    },
    {
      id: 'in-progress' as const,
      title: ['進行中'],
      count: counts.inProgress,
      icon: dashboardIcon3,
    },
    {
      id: 'completed' as const,
      title: ['完了'],
      count: counts.completed,
      icon: dashboardIcon4,
    },
  ];

  return (
    <div className="dashboard-cards">
      <div className="dashboard-cards__container">
        {cards.map((card) => (
          <div key={card.id} className="dashboard-cards__card">
            <div className="dashboard-cards__icon">
              <img src={card.icon} alt="" className="dashboard-cards__icon-img" aria-hidden />
            </div>
            <div className="dashboard-cards__content">
              <div className="dashboard-cards__count">{loading ? '—' : card.count}</div>
              <div className="dashboard-cards__title">
                {Array.isArray(card.title) ? (
                  card.title.map((line, index) => (
                    <React.Fragment key={index}>
                      {line}
                      {index < card.title.length - 1 && <br />}
                    </React.Fragment>
                  ))
                ) : (
                  card.title
                )}
              </div>
            </div>
          </div>
        ))}
      </div>
    </div>
  );
};

export default DashboardCards;
